// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_MarketCountriesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_MarketCountriesResponse — locations-service countries
 * annotated with the billing market verdict (D6).
 * Used by GET /subscriptions/admin/market-countries (Full-only).
 */
import type { Subscriptions_MarketCountryRow } from './Subscriptions_MarketCountryRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Subscriptions_MarketCountriesResponseDados {
rows: Subscriptions_MarketCountryRow[]
}

export type Subscriptions_MarketCountriesResponse = ApiResponse<Subscriptions_MarketCountriesResponseDados>;

registerResponseContract('Subscriptions_MarketCountriesResponse', {
  rows: {
    type: 'array',
    required: true,
    items: {
      id:            { type: 'number',  required: false },
      code:          { type: 'string',  required: false },
      name:          { type: 'string',  required: false },
      billing_ready: { type: 'boolean', required: false },
      currency:      { type: 'string',  required: false },
      currencies:    { type: 'array',   required: false },
    },
  },
})
